module.exports = __webpack_public_path__ + "img/1e47e5b.png";